export default "__VITE_ASSET__DoiHbQ0k__"